var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getting_ready"},[_c('p',[_vm._v("Getting ready for a meeting…")]),_c('button',{staticClass:"color_btn hover_op",on:{"click":_vm.join}},[_vm._v("Join now")])])}
var staticRenderFns = []

export { render, staticRenderFns }